import React, { useState } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import { IconArrowHead } from '../../../../components';
import Slider from 'react-slick';

import css from './SectionTutorReviews.module.css';
import client1Image from './images/1.png';
import client1Sign from './images/sign.svg';

const NextArrow = ({ onClick }) => (
  <div className={classNames(css.arrow, css.arrowRight)} onClick={onClick}>
    <IconArrowHead direction="right" size="big" />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className={classNames(css.arrow, css.arrowLeft)} onClick={onClick}>
    <IconArrowHead direction="left" size="big" />
  </div>
);

const SectionTutorReviews = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  const [currentSlide, setCurrentSlide] = useState(0);

  const SLIDER_SETTINGS = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: index => setCurrentSlide(index),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const reviews = [
    {
      title: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.title' }),
      review: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.review' }),
      sign: <img src={client1Sign} alt="sign" />,
      client: {
        image: client1Image,
        name: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.clientName' }),
        bio: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.clientBio' }),
      },
    },
    {
      title: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.title' }),
      review: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.review' }),
      sign: <img src={client1Sign} alt="sign" />,
      client: {
        image: client1Image,
        name: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.clientName' }),
        bio: intl.formatMessage({ id: 'LandingPage.SectionTutorReviews.review1.clientBio' }),
      },
    },
  ];

  const hasReviews = !!reviews && reviews?.length > 0;
  const currentReview = reviews[currentSlide];

  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className, css.sectionContent)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        <div className={css.left}>
          {hasHeaderFields ? (
            <header className={classNames(css.header, defaultClasses.sectionDetails)}>
              <Field data={title} className={defaultClasses.title} options={fieldOptions} />
              <Field
                data={description}
                className={defaultClasses.description}
                options={fieldOptions}
              />
              <Field
                data={callToAction}
                className={defaultClasses.ctaButton}
                options={fieldOptions}
              />
            </header>
          ) : null}

          <div className={classNames(css.desktopReview, css.reviewWrapper)}>
            <div className={css.reviewBlock}>
              <div className={css.reviewTitle}>{currentReview.title}</div>
              <div className={css.review}>{currentReview.review}</div>
            </div>
            <div className={css.sign}>{currentReview.sign}</div>
          </div>
        </div>

        {hasReviews ? (
          <div className={css.right}>
            <Slider {...SLIDER_SETTINGS} className={css.slider}>
              {reviews.map(review => (
                <div className={css.reviewContainer}>
                  <div className={css.client}>
                    <img
                      className={css.clientImage}
                      alt={review.client.name}
                      src={review.client.image}
                    />
                    <div className={css.clientDetails}>
                      <div className={css.name}>{review.client.name}</div>
                      <div className={css.description}>{review.client.bio}</div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            <div className={classNames(css.mobileReview, css.reviewWrapper)}>
              <div className={css.reviewBlock}>
                <div className={css.reviewTitle}>{currentReview.title}</div>
                <div className={css.review}>{currentReview.review}</div>
              </div>
              <div className={css.sign}>{currentReview.sign}</div>
            </div>
          </div>
        ) : null}
      </div>
    </SectionContainer>
  );
};

SectionTutorReviews.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionTutorReviews.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default SectionTutorReviews;
